<div class="fullScreen">

  <div style="width: 100%;" >
      <div class="imgLogoPlurisLogin">
      </div>
  </div>

 <!-- <div style="width: 100%;" >
      <div class="imglogoQualidadeLogin">
      </div>
  </div>-->

  <mat-grid-list cols="4" rowHeight="1:1" >

    <div class="forms">
      <mat-grid-tile *ngIf="cadastroComponent; else formLogin" colspan="1" rowspan="2">
        <app-cadastro (exibirPainel)="exibirPainel($event)"></app-cadastro>
      </mat-grid-tile>

        <ng-template #formLogin>
          <mat-grid-tile colspan="4" rowspan="2" >
            <app-login (exibirPainel)="exibirPainel($event)"></app-login>
          </mat-grid-tile>
        </ng-template>
    </div>

  </mat-grid-list>
</div>

